import { render, staticRenderFns } from "./PcPcmRegnTap1Graph.vue?vue&type=template&id=630d68b6&"
import script from "./PcPcmRegnTap1Graph.vue?vue&type=script&lang=js&"
export * from "./PcPcmRegnTap1Graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports